export default __webpack_public_path__ + "img/tab1and2_nav1-1-938197ef.png";